// 判斷是否為 iOS 裝置（iPhone / iPad / iPod）。
// iPadOS 13+ 在「要求桌面版網站」模式下，Safari 的 user-agent 會偽裝成
// Macintosh 且不含 iPad，導致無法用字串比對辨識。此時改用 maxTouchPoints
// 輔助判斷：真正的 Mac 為 0，iPad 仍會回報 > 1。
export const isIOSDevice = () => {
  const ua = navigator.userAgent;
  return /iPad|iPhone|iPod/.test(ua) || (navigator.maxTouchPoints > 1 && /Macintosh/.test(ua));
};
